"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _react = _interopRequireWildcard(require("react"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _Cart = babelHelpers.interopRequireDefault(require("Cart"));

var _noty = require("noty");

var _SiteNavigation = babelHelpers.interopRequireDefault(require("components/SiteNavigation"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || babelHelpers.typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Channel = _exports.default.Channel,
    Session = _exports.default.Session;
var ProductCard = (_class = /*#__PURE__*/function (_Card) {
  babelHelpers.inherits(ProductCard, _Card);

  var _super = _createSuper(ProductCard);

  function ProductCard() {
    var _thisSuper, _this;

    babelHelpers.classCallCheck(this, ProductCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this, "isProductsPage", _descriptor, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "linkTarget", _descriptor2, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "priceInfo", _descriptor3, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "quantity", _descriptor4, babelHelpers.assertThisInitialized(_this));
    _this.state = Object.assign(babelHelpers.get((_thisSuper = babelHelpers.assertThisInitialized(_this), babelHelpers.getPrototypeOf(ProductCard.prototype)), "state", _thisSuper) || {}, {
      inputQuantity: null
    });
    return _this;
  }

  babelHelpers.createClass(ProductCard, [{
    key: "renderImage",
    value: function renderImage() {
      if (this.isProductsPage) {
        return /*#__PURE__*/_react.default.createElement("a", {
          href: this.linkTarget,
          className: "image",
          style: {
            backgroundImage: "url(".concat(this.scaleImage ? "/t/width=400/matte=none/scale/f".concat(this.image, "/image.jpg") : this.image, ")")
          }
        });
      }

      return babelHelpers.get(babelHelpers.getPrototypeOf(ProductCard.prototype), "renderImage", this).call(this);
    }
  }, {
    key: "renderTileBody",
    value: function renderTileBody() {
      if (this.isProductsPage) {
        return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
          href: this.linkTarget
        }, /*#__PURE__*/_react.default.createElement("h3", null, this.objectTitle)), this.promoText && this.objectListingSummary != this.promoText ? /*#__PURE__*/_react.default.createElement("p", {
          className: "promoText"
        }, this.promoText) : null, this.objectListingSummary ? /*#__PURE__*/_react.default.createElement("p", {
          className: this.objectListingClasses
        }, this.objectListingSummary) : null);
      }

      return babelHelpers.get(babelHelpers.getPrototypeOf(ProductCard.prototype), "renderTileBody", this).call(this);
    }
  }, {
    key: "getItemPriceText",
    value: function getItemPriceText() {
      var _this$priceInfo = this.priceInfo,
          basePrice = _this$priceInfo.basePrice,
          salePrice = _this$priceInfo.salePrice;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
        className: "basePrice".concat(basePrice != salePrice ? ' strike' : '')
      }, this.formatPrice(basePrice)), basePrice != salePrice ? /*#__PURE__*/_react.default.createElement("span", {
        className: "salePrice"
      }, this.formatPrice(salePrice)) : null);
    }
  }, {
    key: "formatPrice",
    value: function formatPrice(amount) {
      amount = Number(amount).toFixed(2);

      var _amount$split = amount.split('.'),
          _amount$split2 = babelHelpers.slicedToArray(_amount$split, 2),
          whole = _amount$split2[0],
          dec = _amount$split2[1];

      var dd = '';

      while (whole.length > 3) {
        dd = ",".concat(whole.substr(-3));
        whole = whole.substring(0, whole.length - 3);
      }

      dd = whole + dd;
      return "$".concat(dd, ".").concat(dec);
    }
  }, {
    key: "setQuantity",
    value: function setQuantity(event) {
      var v = event.target.value.replace(/[^0-9]/g, '');
      this.setState({
        inputQuantity: v
      });
    }
  }, {
    key: "renderAdditionalTileContents",
    value: function renderAdditionalTileContents() {
      if (this.isProductsPage) {
        return /*#__PURE__*/_react.default.createElement("form", {
          className: "product-form bottom",
          onSubmit: this.addToCart
        }, /*#__PURE__*/_react.default.createElement("input", {
          type: "hidden",
          name: "id",
          value: this.id
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "price"
        }, this.getItemPriceText()), /*#__PURE__*/_react.default.createElement("input", {
          type: "number",
          name: "quantity",
          value: this.state.inputQuantity === null ? this.quantity : this.state.inputQuantity,
          onChange: this.setQuantity,
          className: "form-control quantity"
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "total"
        }, /*#__PURE__*/_react.default.createElement("button", {
          className: "btn btn-default",
          type: "submit"
        }, "Add")));
      }

      return babelHelpers.get(babelHelpers.getPrototypeOf(ProductCard.prototype), "renderAdditionalTileContents", this).call(this);
    }
  }, {
    key: "addToCart",
    value: function addToCart(event) {
      var _this2 = this;

      event.preventDefault();
      if (!this.state.inputQuantity && !this.quantity) return;
      (0, _fetch.default)('data/cart/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          product: this.id,
          quantity: this.state.inputQuantity === null ? this.quantity : Number(this.state.inputQuantity)
        })
      }).then(function (data) {
        return data.json();
      }).then(function (data) {
        if (data.ok) {
          _Cart.default.updateCart();

          (0, _noty.showNotification)({
            text: "Added product to cart.",
            id: "addedProduct",
            count: 1,
            update: function update(options) {
              this.count += options.count;
              return "Added " + this.count + " products to cart.";
            }
          });

          _SiteNavigation.default.cartUpdated();

          _this2.setState({
            inputQuantity: null
          });
        }
      });
    }
  }]);
  return ProductCard;
}(_base.default), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "isProductsPage", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "linkTarget", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "priceInfo", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "quantity", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setQuantity", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setQuantity"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "addToCart", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "addToCart"), _class.prototype)), _class);
exports.default = ProductCard;